function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { startLoadingSellerByProject } from '../../actions/project';
import buildMiddleware from './template';
const withSellerFetch = SubComponent => {
  const WithSellerFetchWrapper = buildMiddleware(SubComponent, 'WithSeller');
  const WithSellerFetch = class extends Component {
    constructor(props) {
      super(props);
      this.state = {
        loadedOnce: false
      };
    }
    static getDerivedStateFromProps(props, state) {
      return props.loading && !state.loadedOnce ? {
        ...state,
        loadedOnce: true
      } : state;
    }
    componentDidMount() {
      this.props.startLoadingSellerByProject(this.props.selectedProjectId);
    }
    render() {
      const {
        startLoadingSellerByProject,
        loading,
        ...passThroughProps
      } = this.props;
      return /*#__PURE__*/React.createElement(WithSellerFetchWrapper, _extends({
        loading: loading && !this.state.loadedOnce
      }, passThroughProps));
    }
  };
  const mapStateToProps = _ref => {
    let {
      project
    } = _ref;
    return {
      selectedProjectId: project.selectedProjectId,
      loading: project.sellerLoading || !project.selectedProjectSeller && !project.sellerError,
      error: project.sellerError
    };
  };
  const mapDispatchToProps = dispatch => ({
    startLoadingSellerByProject: projectId => dispatch(startLoadingSellerByProject(projectId))
  });
  WithSellerFetch.propTypes = {
    selectedProjectId: PropTypes.string.isRequired,
    startLoadingSellerByProject: PropTypes.func.isRequired
  };
  return connect(mapStateToProps, mapDispatchToProps)(WithSellerFetch);
};
export default withSellerFetch;